module.exports = __webpack_public_path__ + "img/4_Proximal Ascending Colon.f35e21d3.png";